<template>
  <div>
    <Form
      ref="formValidate" :model="formValidate"
      :rules="ruleValidate" :label-width="150"
    >
      <div class="detail-header">
        <span>基本信息</span>
        <span style="color:#105cfb; float: right; cursor: pointer;" @click="pictureCtrl = true">线索拦截规则</span>
      </div>
      <div class="base-message detail-form">
        <Row>
          <FormItem label="任务名称" prop="missionId">
            <mySelect
              v-if="!clueDetail && !taskObj"
              ref="selectConditions"
              :path="'/business/missions/team'"
              :key-name="'name'"
              placeholder="请选择任务"
              :default-obj="taskObj || {}"
              @getValue="getMissionId"
            />
            <span v-if="clueDetail || taskObj">{{ clueDetail?(clueDetail.missionName || ""):(taskObj.name || "") }}</span>
            <p v-if="isWhiteConflict" class="warn">该线索报备店铺为授权店</p>
            <p v-if="isSupplierConflict" class="warn">该线索店铺已被其他单位打击</p>
          </FormItem>
        </Row>
        <Row>
          <FormItem label="侵权方式" prop="tortType">
            <Select
              v-model="formValidate.tortType" placeholder="请选择侵权方式"
              @on-change="changeTortType"
            >
              <Option
                v-for="item in tortTypeArr" :key="item.id"
                :value="item.value"
              >{{ item.nameZh }}</Option>
            </Select>
          </FormItem>
        </Row>
        <Row v-if="formValidate.tortType=='E_EC'" key="channelType">
          <FormItem
            label="销售渠道" prop="channelType"
            :rules="{ required: true, message: '销售渠道不能为空', trigger: 'change' }"
          >
            <Select v-model="formValidate.channelType" placeholder="请选择销售渠道">
              <Option
                v-for="item in ecChannelArr" :key="item.id"
                :value="item.value"
              >{{ item.nameZh }}</Option>
            </Select>
          </FormItem>
        </Row>
        <Row v-if="formValidate.tortType=='E_EC'&&formValidate.channelType=='OT'" key="platformName">
          <FormItem
            label="平台名称"
            prop="platformName"
            :rules="{ max:128,message:'不能超过128个字符',trigger:'blur'}"
          >
            <Input v-model.trim="formValidate.platformName" placeholder="请输入平台名称" />
          </FormItem>
        </Row>
        <Row v-if="formValidate.tortType.indexOf('E')>-1" key="storeUrl">
          <FormItem
            :label="(formValidate.tortType=='E_WL'?'网页':'店铺')+'链接'"
            :rules="
              formValidate.tortType=='E_WL' || formValidate.channelType=='DY' || formValidate.channelType=='OT'?
                ( (formValidate.channelType==='DY' || formValidate.channelType=='OT' ) ?[{required: true, message: '店铺链接不能为空', trigger: 'blur'}, {required: true,max:1024, message: '链接长度不能大于1024个字符', trigger: 'blur'}]: [{type:'url', message: ('网页链接不正确'), trigger: 'blur'}]):
                [{required: true, message: '店铺链接不能为空', trigger: 'blur'},{type:'url', message:'店铺链接不正确', trigger: 'blur'},{required: true,max:1024, message: '链接长度不能大于1024个字符', trigger: 'blur'}]"
            prop="storeUrl"
          >
            <Input
              v-model="formValidate.storeUrl" :placeholder="'请输入'+(formValidate.tortType=='E_WL'?'网页':'店铺')+'链接'"
              @on-blur="confictCheckout(formValidate.channelType)"
            />
          </FormItem>
        </Row>
        <Row>
          <FormItem :label="(formValidate.tortType=='S_FA'?'工厂':'店铺')+'名称'" prop="storeName">
            <Input
              v-model.trim="formValidate.storeName" :placeholder="'请输入'+(formValidate.tortType=='S_FA'?'工厂':'店铺')+'名称'"
              @on-blur="confictCheckout(formValidate.channelType)"
            />
          </FormItem>
        </Row>
        <Row v-if="formValidate.tortType.indexOf('S')>-1" key="suveryArea">
          <FormItem
            label="调查区域" prop="province"
            :rules="{required: true, message: '调查区域不能为空', trigger: 'blur'}"
          >
            <City
              :city-list="cityList" style="width:100%;"
              @listenCity="getCity($event,'suveryArea')"
            />
          </FormItem>
        </Row>
        <Row v-if="formValidate.tortType.indexOf('S')>-1" key="address">
          <FormItem
            label="侵权地址"
            prop="address"
            :rules="[
              {required: true, message: '侵权地址不能为空', trigger: 'blur'},
              { max:128,message:'不能超过128个字符',trigger:'blur'}
            ]"
          >
            <Input
              v-model.trim="formValidate.address" type="textarea"
              :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入调查详细地址"
            />
          </FormItem>
        </Row>
        <Row v-if="formValidate.tortType.indexOf('S')>-1" key="valid">
          <FormItem label="是否侵权" prop="valid">
            <RadioGroup v-model="formValidate.valid" @on-change="changeValid">
              <Radio :label="1">是</Radio>
              <Radio :label="0">否</Radio>
            </RadioGroup>
          </FormItem>
        </Row>
        <Row v-if="formValidate.tortType.indexOf('E')>-1&&formValidate.tortType!='E_WL'&&['TT', 'TS', 'PD'].includes(formValidate.channelType)" key="dispenser">
          <FormItem
            label="掌柜号"
            prop="dispenser"
            :rules="formValidate.tortType.indexOf('E')>-1&&formValidate.channelType=='TT'?[{required: true, message: '掌柜号不能为空', trigger: 'blur'},{ max:64,message:'不能超过64个字符',trigger:'blur'}]:{}"
          >
            <Input
              v-model.trim="formValidate.dispenser" placeholder="请输入掌柜号"
              @on-blur="confictCheckout(formValidate.channelType)"
            />
          </FormItem>
        </Row>
        <Row v-if="formValidate.valid===1" key="hasProduct">
          <FormItem label="是否有产品" prop="hasProduct">
            <RadioGroup v-model="formValidate.hasProduct">
              <Radio :label="1">是</Radio>
              <Radio :label="0">否</Radio>
            </RadioGroup>
          </FormItem>
        </Row>
        <!-- 线上侵权才需要该字段，线上侵权都是'E_XXX' -->
        <Row v-if="formValidate.valid === 1 && formValidate.tortType.indexOf('E')>-1" key="needPurchase">
          <FormItem
            label="是否需要购买实物" prop="needPurchase"
            :rules="[{type: 'number', required: true, message: '该项为必填项', trigger:'change'}]"
          >
            <RadioGroup v-model="formValidate.needPurchase">
              <Radio :label="1">是</Radio>
              <Radio :label="0">否</Radio>
            </RadioGroup>
          </FormItem>
        </Row>
        <Row v-if="formValidate.hasProduct===1&&formValidate.valid===1" key="productName">
          <FormItem
            label="产品名称"
            prop="clueProduct.productName"
            :rules="[
              {required: true, message: '产品名称不能为空', trigger: 'blur'},
              { max:128,message:'不能超过128个字符',trigger:'blur'}
            ]"
          >
            <Input v-model.trim="formValidate.clueProduct.productName" placeholder="请输入产品名称" />
          </FormItem>
        </Row>
        <Row v-if="formValidate.hasProduct===1&&formValidate.tortType.indexOf('E')>-1&&formValidate.valid===1" key="productUrl">
          <FormItem
            label="产品链接"
            prop="clueProduct.productUrl"
            :rules="
              (formValidate.channelType==='DY' || formValidate.channelType=='OT' ) ?
                [{required: true, message: '产品链接不能为空', trigger: 'blur'},
                 {required: true,max:2048, message: '产品链接长度不能大于2048个字符', trigger: 'blur'}]: [
                   {required: true, message: '产品链接不能为空', trigger: 'blur'},
                   {type:'url', message: ('产品链接不正确'), trigger: 'blur'},
                   {required: true,max:2048, message: '产品链接长度不能大于2048个字符', trigger: 'blur'}]
            "
          >
            <Input v-model="formValidate.clueProduct.productUrl" placeholder="请输入产品链接" />
          </FormItem>
        </Row>
        <Row v-if="formValidate.hasProduct===1&&formValidate.valid===1" key="price">
          <FormItem
            label="产品单价"
            prop="clueProduct.price"
            :rules="formValidate.tortType.indexOf('E')>-1?[{required: true,type:'number', message: '产品单价不能为空', trigger: 'blur'},numberValid,maxNumberValid]:[numberValid,maxNumberValid]"
          >
            <Input v-model.number="formValidate.clueProduct.price" placeholder="请输入产品单价(数字)" />
          </FormItem>
        </Row>
        <Row v-if="formValidate.hasProduct===1&&formValidate.valid===1" key="saleNum">
          <FormItem
            label="销量"
            prop="clueProduct.saleNum"
            :rules="formValidate.tortType.indexOf('E')>-1?[{required: true,type:'number', message: '销量不能为空', trigger: 'blur'},numberValid,maxNumberValid]:[numberValid,maxNumberValid]"
          >
            <Input v-model.number="formValidate.clueProduct.saleNum" placeholder="请输入销量(数字)" />
          </FormItem>
        </Row>
        <Row v-if="formValidate.hasProduct===1&&formValidate.valid===1 && formValidate.tortType.indexOf('E')>-1" key="comment">
          <FormItem
            label="评论数"
            prop="clueProduct.comment"
            :rules="formValidate.channelType=='PD'?[{required: true,type:'number', message: '评论数不能为空', trigger: 'blur'},numberValid,maxNumberValid]:[numberValid,maxNumberValid]"
          >
            <Input v-model.number="formValidate.clueProduct.comment" placeholder="请输入评论数(数字)" />
          </FormItem>
        </Row>
        <Row v-if="formValidate.tortType=='E_EC'&&formValidate.channelType=='AL'&&formValidate.hasProduct===1&&formValidate.valid===1" key="batchNum">
          <FormItem
            label="起批量"
            prop="clueProduct.batchNum"
            :rules="[numberValid,maxNumberValid]"
          >
            <Input v-model.number="formValidate.clueProduct.batchNum" placeholder="请输入起批量(数字)" />
          </FormItem>
        </Row>
        <Row>
          <FormItem label="调查时间" prop="surveyDate">
            <DatePicker
              type="date" placeholder="请选择调查时间"
              style="width:100%" format="yyyy-MM-dd"
              :value="formValidate.surveyDate" placement="bottom-start"
              @on-change="getSurveyDate"
            />
          </FormItem>
        </Row>
        <Row>
          <FormItem label="备注" prop="remark">
            <Input
              v-model.trim="formValidate.remark" type="textarea"
              :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"
            />
          </FormItem>
        </Row>
        <Row>
          <FormItem label="侵权照片/录像/附件" prop="attachmentList">
            <file-upload
              :default-list="defaultList || []"
              :upload-config="uploadConfig"
              @getFileList="getAttachmentList"
            />
          </FormItem>
        </Row>
      </div>
      <div v-if="formValidate.valid===1" class="detail-header">
        <span>侵权主体</span>
        <span
          class="icon-increase-01 add-icon" title="新增侵权主体"
          @click="handleAdd('clueTortSubjectList')"
        ></span>
      </div>
      <template v-if="formValidate.valid===1&&isDetailLoad">
        <div
          v-for="(item, index) in formValidate.clueTortSubjectList"
          :key="'clueTortSubjectList.' + item.id"
          class="clue-tort-subject detail-form"
        >
          <span v-if="item.index!=1" class="divider"></span>
          <span
            v-if="(formValidate.clueTortSubjectList.length!=1)" class="icon-down-01 remove-icon"
            @click="handleRemove('clueTortSubjectList',index)"
          ></span>
          <tort-subject-form
            :ref="'tortSubjectDom'+index" :not-require="isRules()"
            :default-data="item || ''" :form-validate="formValidate"
            @getList="getTortList($event,index)" @changeBtn="savePRLoadingFn"
          />
        </div>
      </template>
    </Form>
    <Row class="detail-btn-box">
      <Button
        type="primary" style="margin-right:10px;"
        :disabled="savePRLoading" @click="validConflict"
      >提交</Button>
      <Button @click="$emit('changeEditCtrl',false);">取消</Button>
    </Row>

    <Modal
      v-model="tipsCtrl"
      title="报备确认"
      :width="360"
      :footer-hide="true"
    >
      <Row class="modal-tips">当前线索信息疑似已被报备，继续提交可能会被项目经理驳回，是否继续提交？</Row>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button
          type="primary" :disabled="savePRLoading"
          :loading="savePRLoading" @click="handleSubmit(true)"
        >确认</Button>
        <Button style="margin-left: 8px" @click="tipsCtrl=false;">取消</Button>
      </Row>
    </Modal>
    <Modal
      v-model="confictCtrl"
      title="冲突提示"
      :width="360"
      :footer-hide="true"
    >
      <Row class="modal-tips">当前线索店铺与白名单冲突，请修改后再提交！</Row>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button type="primary" @click="confictCtrl=false;">确认</Button>
      </Row>
    </Modal>
    <Modal
      v-model="pictureCtrl"
      title="线索拦截规则"
      :width="700"
      :footer-hide="true"
    >
      <div style="width: 100%; text-align: center;">
        <img
          src="../../../assets/images/律师报备线索规则.jpg" alt=""
          width="650"
        >
      </div>
    </Modal>
    <preview-file ref="perviewFile" />

  </div>
</template>
<script>
import tortSubjectForm from './plugin/tortSubjectForm.vue'
export default {
  components: {
    tortSubjectForm
  },
  props: ['clueDetail', 'taskObj'],
  data () {
    const productUrlCheck = (rule, value, callback) => {
      if (this.formValidate.tortType.indexOf('E') > -1) {
        if (value === '') {
          callback(new Error('请输入产品链接'))
        }
      }
    }
    const overMillion = (rule, value, callback) => {
      if (Number(value) > 100000000) {
        return callback(new Error('金额不能超过一亿'))
      }
      callback()
    }
    return {
      subjectIndex: 1,
      tipsCtrl: false,
      isDetailLoad: true,
      ctrl: false,
      savePRLoading: false,
      pictureCtrl: false,
      cityList: [],
      missionList: [],
      tortTypeArr: [],
      ecChannelArr: [],
      isWhiteConflict: false,
      isSupplierConflict: false,
      confictCtrl: false,
      formValidate: {
        missionId: '',
        tortType: 'E_EC',
        channelType: 'TT',
        platformName: '',
        storeUrl: '',
        storeName: '',
        address: '',
        valid: 1, // 是否侵权选项
        hasProduct: 1, // 是否有产品
        dispenser: '', // 掌柜号
        needPurchase: '', // 是否需要购买实物
        surveyDate: '',
        remark: '',
        province: '',
        city: '',
        area: '',
        attachmentList: [],
        clueProduct: {
          saleNum: '',
          batchNum: '',
          price: '',
          productName: '',
          productUrl: '',
          comment: '' // 评论数
        },
        clueTortSubjectList: [{ status: 1 }]
      },
      ruleValidate: {
        missionId: [
          { required: true, type: 'number', message: '任务名称不能为空', trigger: 'change' }
        ],
        tortType: [
          { required: true, message: '侵权方式不能为空', trigger: 'change' }
        ],
        storeName: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
          { max: 128, message: '不能超过128个字符', trigger: 'blur' }
        ],
        surveyDate: [
          { required: true, message: '调查时间不能为空', trigger: 'blur' }
        ],
        attachmentList: [
          { required: true, type: 'array', message: '附件不能为空', trigger: 'blur' }
        ],
        remark: [
          { max: 512, message: '不能超过512个字符', trigger: 'blur' }
        ]
      },
      longLimit: { max: 100, message: '不能超过100个字符', trigger: 'blur' },
      numberValid: { pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/, message: '请输入正确的数字', trigger: 'blur' },
      maxNumberValid: { validator: overMillion, message: '最大不能超过一亿', trigger: 'blur' },
      // 图片上传参数
      defaultList: [],
      uploadConfig: {
        fileName: '',
        num: 1000
      }
    }
  },
  watch: {
    'formValidate.channelType': {
      handler(newVal, oldVal) {
        console.log('formValidate.channelType', newVal, oldVal)
      }
    }
  },
  created() {

  },
  beforeMount() {
    if (this.taskObj) {
      this.formValidate.missionId = this.taskObj.id
    }
    this.getDictionary()
  },
  mounted() {
    if (this.clueDetail) {
      this.getDeafultData()
    }
  },
  updated() {

  },
  methods: {
    isRules() {
      if (
        this.formValidate.tortType.indexOf('E') > -1 && this.formValidate.tortType !== 'E_WL' &&
        ['TT', 'PD', 'OT', 'DY', 'TS'].includes(this.formValidate.channelType)
      ) {
        return true
      } else {
        return false
      }
    },
    // 搜索条件省市区接口
    getCity(data, name, index) {
      let area
      const dataObj = {}
      if (data.length !== 0) {
        if (data.length === 1) {
          dataObj.province = data[0].value
          dataObj.city = ''
          dataObj.area = ''
          area = data[0].label
        } else if (data.length === 2) {
          dataObj.province = data[0].value
          dataObj.city = data[1].value
          dataObj.area = ''
          area = data[0].label + data[1].label
        } else if (data.length === 3) {
          dataObj.province = data[0].value
          dataObj.city = data[1].value
          dataObj.area = data[2].value
          area = data[0].label + data[1].label + data[2].label
        }
      } else {
        dataObj.province = ''
        dataObj.city = ''
        dataObj.area = ''
        area = ''
      }
      if (name === 'suveryArea') {
        this.formValidate.province = dataObj.province
        this.formValidate.city = dataObj.city
        this.formValidate.area = dataObj.area
      } else {
        // 改变数组中的对象的值，使用$set改变视图
        this.$set(this.formValidate[name][index], 'province', dataObj.province)
        this.$set(this.formValidate[name][index], 'city', dataObj.city)
        this.$set(this.formValidate[name][index], 'area', dataObj.area)
      }
    },
    getSurveyDate(date) {
      this.formValidate.surveyDate = date
    },
    findDelete(prevArr, lastArr) {
      for (let i = 0; i < prevArr.length; i++) {
        for (let k = 0; k < lastArr.length; k++) {
          if (lastArr[k].id === prevArr[i].id) {
            prevArr.splice(i, 1)
            i--
            break
          }
        }
      }
    },
    // 获取图片列表
    getAttachmentList (arr) {
      this.formValidate.attachmentList = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        if (item.id) { obj.id = item.id }
        this.formValidate.attachmentList.push(obj)
      })
    },
    // 是否侵权
    changeValid(label) {
      if (label === 0) {
        this.formValidate.hasProduct = 0
      } else {
        this.formValidate.hasProduct = 1
      }
    },
    // 组装参数提交
    assembleData() {
      const ajaxDataObj = {}
      const formData = this.formValidate
      for (const key in formData) {
        if (key === 'clueTortSubjectList') {
          ajaxDataObj[key] = []
          formData[key].forEach((item, index) => {
            // 如果不侵权则不处理数据
            if (!this.formValidate.valid) { return }
            // 数据验证不通过则直接返回空字符串
            if (!item || JSON.stringify(item) === '{}') {
              ajaxDataObj[key].push('')
              return
            }
            // 如果销售商非必填并且主体名称与主体区域均没有填写则不需要传递给后台
            if (this.isRules() && item.name === '' && item.province === '') { return }
            const obj = {
              category: item.category,
              name: item.name,
              creditCode: item.creditCode,
              legalIdNo: item.legalIdNo,
              legalRepresentative: item.legalRepresentative,
              province: item.province,
              property: item.property,
              city: item.city,
              area: item.area,
              contact: item.contact,
              address: item.address
            }
            if (item.id) {
              obj.id = item.id
            }
            if (item.category === 'S') {
              obj.type = item.type
            }
            ajaxDataObj[key].push(obj)
          })
        } else {
          ajaxDataObj[key] = formData[key]
        }
      }
      return ajaxDataObj
    },
    // 验证线索是否冲突关联冲突
    validConflict() {
      this.confictCheckout(this.formValidate.channelType)
      setTimeout(() => {
        if (!this.savePRLoading) {
          this.submitFn()
        }
      }, 1000)
    },
    submitFn() {
      if (this.formValidate.valid !== 1) {
        this.$refs['formValidate'].validate((valid) => {
          if (valid) {
            this.handleSubmit(true)
          }
        })
        return
      }
      const url = '/business/clue/conflict/lawyer?missionId=' + this.formValidate.missionId
      const ajaxDataObj = {
        missionId: this.formValidate.missionId,
        tortItems: [],
        tortType: this.formValidate.tortType,
        channelType: this.formValidate.channelType,
        storeName: this.formValidate.storeName,
        storeUrl: this.formValidate.storeUrl,
        dispenser: this.formValidate.dispenser

      }
      if (this.clueDetail) {
        ajaxDataObj.clueId = this.clueDetail.id
      }
      this.formValidate.clueTortSubjectList.forEach((item, index) => {
        const obj = {
          category: item.category,
          name: item.name
        }
        ajaxDataObj.tortItems.push(obj)
      })
      // 线上的线索则还需要提交产品地址
      if (this.formValidate.tortType.indexOf('E') > -1 && this.formValidate.hasProduct === 1) {
        ajaxDataObj.productUrls = [this.formValidate.clueProduct.productUrl]
      }
      let tortSubjectIndex = 0
      let isGoOn = true
      // 销售商、生产商组件手动校验
      // 校验销售商、生产商是否有不通过的数据，并且校验是否必须统计销售商的个数
      this.formValidate.clueTortSubjectList.forEach((item, index) => {
        const flag = this.$refs[`tortSubjectDom${index}`][0].submitValid()
        if (item.category === 'S') { tortSubjectIndex++ }
        if (!flag) {
          isGoOn = flag
          return
        }
      })
      this.handleSubmit(false, url, ajaxDataObj, tortSubjectIndex, isGoOn)
    },
    ReportConfirmation(url, ajaxDataObj, tortSubjectIndex, isGoOn) {
      this.$refs['formValidate'].validate((valid) => {
        if (valid && isGoOn) {
          if (!this.isRules() && tortSubjectIndex === 0 && this.formValidate.valid) {
            this.$Message.error('侵权主体中必须存在一个销售商，请完善销售商资料！')
            return
          }
          // 0无冲突，1有冲突，2有关联，3冲突又关联
          this.$post(url, ajaxDataObj).then(res => {
            this.savePRLoading = false
            if (res.code === 0) {
              if (res.data === 0 || res.data === 2) {
                this.handleSubmit(true)
              } else if (res.data === 1 || res.data === 3) {
                this.tipsCtrl = true
              }
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },

    // 表单的冲突验证
    confictCheckout(channelType) {
      this.clearConfictShow()
      this.whiteConflict(channelType)
    },
    clearConfictShow() {
      this.isWhiteConflict = false
      this.isSupplierConflict = false
    },
    // 查询白名单冲突
    whiteConflict(channelType) {
      if (this.formValidate.missionId) {
        const url = '/business/mission/' + this.formValidate.missionId
        this.$get(url).then(res => {
          const url2 = '/business/roster/whitelist/conflict'
          const ajaxData = {
            projectId: res.data.projId,
            tortCategory: (this.formValidate.tortType === 'E_EC' || this.formValidate.tortType === 'E_WL') ? 2 : 1,
            storeName: this.formValidate.storeName,
            storeUrl: this.formValidate.storeUrl,
            platform: this.formValidate.channelType
          }
          if (channelType === 'TT') { // 淘宝
            ajaxData.dispenser = this.formValidate.dispenser
          }
          if (this.formValidate.tortType === 'E_WL') { // 网页链接
            delete ajaxData.platform
            delete ajaxData.dispenser
          }
          if (this.formValidate.tortType !== 'E_EC' && this.formValidate.tortType !== 'E_WL') { // 实体店铺、工厂等
            delete ajaxData.storeUrl
            delete ajaxData.platform
            delete ajaxData.dispenser
          }
          this.$post(url2, ajaxData).then(res => {
            if (res.data) {
              // 说明有冲突 禁用按钮
              this.savePRLoading = true
              this.isWhiteConflict = true
              if (this.clueDetail) { // 是编辑 并且有白名单冲突
                this.confictCtrl = true
              }
            } else {
              this.savePRLoading = false // 取消禁用按钮
              this.clearConfictShow()
              this.supplierConflict(channelType)
            }
          })
        })
      }
    },

    // 查询供应商冲突
    supplierConflict(channelType) {
      if (this.formValidate.missionId) {
        const url = '/business/mission/' + this.formValidate.missionId
        this.$get(url).then(res => {
          const url2 = '/business/roster/supplier/conflict'
          const ajaxData = {
            projectId: res.data.projId,
            tortCategory: (this.formValidate.tortType === 'E_EC' || this.formValidate.tortType === 'E_WL') ? 2 : 1,
            storeName: this.formValidate.storeName,
            storeUrl: this.formValidate.storeUrl,
            platform: this.formValidate.channelType
          }
          if (channelType === 'TT') { // 淘宝
            ajaxData.dispenser = this.formValidate.dispenser
          }
          if (this.formValidate.tortType === 'E_WL') { // 网页链接
            delete ajaxData.platform
            delete ajaxData.dispenser
          }
          if (this.formValidate.tortType !== 'E_EC' && this.formValidate.tortType !== 'E_WL') { // 实体店铺、工厂等
            delete ajaxData.storeUrl
            delete ajaxData.platform
            delete ajaxData.dispenser
          }
          this.$post(url2, ajaxData).then(res => {
            if (res.data) {
              this.isSupplierConflict = true
            } else {
              this.clearConfictShow()
            }
          })
        })
      }
    },
    // 提交按钮
    handleSubmit (bol, url, ajaxDataObj, tortSubjectIndex, isGoOn) {
      this.tipsCtrl = false
      // 组装数据
      const ajaxData = this.assembleData()
      const urlData = bol ? '/business/clue' : '/business/intercept/clue'

      if (this.clueDetail) {
        ajaxData.id = this.clueDetail.id
        // 如果状态是撤回，则将其改为待审核
        if (this.clueDetail.state === 'W') {
          ajaxData.state = 'P'
        }
      }
      this.savePRLoading = true
      // 判断是否有删除的附件,过滤掉有id的附件
      ajaxData.attachmentList = ajaxData.attachmentList.filter((item, index) => {
        return (!item.id) && item
      })
      if (!this.clueDetail) {
        this.$post(urlData, ajaxData).then(res => {
          this.savePRLoading = false
          if (res.code === 0) {
            if (url) {
              this.ReportConfirmation(url, ajaxDataObj, tortSubjectIndex, isGoOn)
            } else {
              this.$Message.success('操作成功')
              this.$emit('changeEditCtrl', true)
            }
          } else {
            this.$Message.error(res.message || '请填写任务名称')
          }
        })
      } else {
        if (bol) {
          this.findDelete(this.defaultList, this.formValidate.attachmentList)
          ajaxData.deleteIdList = this.defaultList.map((item) => {
            return item.id
          })
        }
        let request = ''
        request = url ? '$post' : '$patch'
        this[request](urlData, ajaxData).then(res => {
          this.savePRLoading = false
          if (res.code === 0) {
            if (url) {
              this.ReportConfirmation(url, ajaxDataObj, tortSubjectIndex, isGoOn)
            } else {
              this.$Message.success('操作成功')
              this.$emit('changeEditCtrl', true)
            }
          } else {
            this.$Message.error(res.message)
          }
        })
      }
    },
    changeTortType(data) {
      if (data.indexOf('E') > -1) {
        this.formValidate.province = ''
        this.formValidate.city = ''
        this.formValidate.area = ''
      } else {
        this.formValidate.needPurchase = ''
      }
    },
    // 动态增加侵权主体
    handleAdd (type) {
      this.subjectIndex++
      const obj = {
        id: this.subjectIndex,
        category: 'S',
        property: 'E',
        name: '',
        type: 'E',
        creditCode: '',
        legalIdNo: '',
        legalRepresentative: '',
        address: '',
        province: '',
        city: '',
        contact: '',
        area: ''
      }
      this.formValidate.clueTortSubjectList.unshift(obj)
    },
    handleRemove (type, index) {
      this.formValidate.clueTortSubjectList.splice(index, 1)
    },
    // 可搜索的select框
    getMissionId (data) {
      this.formValidate.missionId = data.id
    },
    // 赋默认值
    getDeafultData() {
      const t = this
      this.isDetailLoad = false
      this.formValidate.missionId = this.clueDetail.missionId
      this.formValidate.tortType = this.clueDetail.tortType
      this.formValidate.channelType = this.clueDetail.channelType
      this.formValidate.platformName = this.clueDetail.platformName
      this.formValidate.storeUrl = this.clueDetail.storeUrl
      this.formValidate.storeName = this.clueDetail.storeName
      this.formValidate.address = this.clueDetail.address
      this.formValidate.valid = this.clueDetail.valid ? 1 : 0
      this.formValidate.hasProduct = this.clueDetail.hasProduct ? 1 : 0
      this.formValidate.needPurchase = this.clueDetail.needPurchase ? 1 : 0
      this.formValidate.dispenser = this.clueDetail.dispenser
      this.formValidate.surveyDate = this.clueDetail.surveyDate
      this.formValidate.remark = this.clueDetail.remark
      this.formValidate.province = this.clueDetail.province
      this.formValidate.city = this.clueDetail.city
      this.formValidate.area = this.clueDetail.area
      this.cityList = [this.clueDetail.province, this.clueDetail.city, this.clueDetail.area]
      this.formValidate.attachmentList = this.clueDetail.attachmentList
      this.defaultList = JSON.parse(JSON.stringify(this.clueDetail.attachmentList))
      this.formValidate.clueProduct = this.clueDetail.clueProduct || {}

      const clueTortSubjectArr = this.clueDetail.clueTortSubjectList || []
      if (clueTortSubjectArr.length !== 0) {
        this.formValidate.clueTortSubjectList = []
        clueTortSubjectArr.forEach((item, index) => {
          const obj = {
            id: item.id,
            category: item.category,
            name: item.name,
            creditCode: item.creditCode,
            legalIdNo: item.legalIdNo,
            legalRepresentative: item.legalRepresentative,
            province: item.province,
            property: item.property,
            city: item.city,
            area: item.area,
            contact: item.contact,
            address: item.address,
            cityList: [item.province || '', item.city || '', item.area || '']
          }
          if (item.category === 'S') {
            obj.type = item.type
          }
          this.formValidate.clueTortSubjectList.push(obj)
        })
      }
      setTimeout(function() {
        t.isDetailLoad = true
      }, 50)
    },
    getTortSubjectInfo(data, item, index) {
      item.tortSubject = data.compayName.trim()
      if (item.tortSubjectProperty === 'P') {
        item.legalRepresentative = data.creditCode // 身份证号
      } else {
        item.tortSubjectNo = data.creditCode // 统一社会信用代码
        item.legalRepresentative = data.legalPersonName // 法定代表人||经营者
        item.legalIdNo = data.legalIdNo // 经营者身份证号
      }
      if (data.address) {
        item.cityList = [data.address.provinceCode, data.address.cityCode, data.address.areaCode]
        const name = 'transEvent' + index
        this.$nextTick(function() {
          this.$refs[name][0].uploadData()
        })
      }
    },
    getTortList(data, index) {
      this.$set(this.formValidate.clueTortSubjectList, index, data)
    },
    // 数据字典
    async getDictionary() {
      this.tortTypeArr = await this.common.getDictionaryItems('tort_type')
      this.ecChannelArr = await this.common.getDictionaryItems('ec_channel')
    },
    savePRLoadingFn(bool) {
      this.savePRLoading = bool
    }
  }
}
</script>
<style lang="scss" scoped>
@import  './clueForm.scss';
    .warn{
        padding-left: 5px;
        color: red;
    }
</style>



// WEBPACK FOOTER //
// src/view/clue/myClue/clueForm.vue